// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"703":"d4c0761f","880":"b6e895b4"}[chunkId] + ".chunk.js";
};